import { useSearchParams } from "react-router-dom";
import { thisBaseURL} from "../../utils/helper.js";

function Login() {
	const [searchParams, setSearchParams] = useSearchParams();
  	let redirectLogout = "false";
  	if(searchParams){
		if(searchParams.get('redirectLogout')){
			redirectLogout = searchParams.get('redirectLogout');
		}
	}
	sessionStorage.setItem('redirectLogout', redirectLogout);
	window.location.replace(thisBaseURL + '/saml/login');
 
  return (
    <div />
  );
}
export default Login;